// rgba(225, 245, 255, 1)

import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import React from "react";

const usePerspectivePeriodStyles = makeThemedStyles(
  "PerspectivePeriod",
  (theme) => ({
    root: {
      margin: 0,
      letterSpacing: "0.05625px",
      fontSize: "1.4em",
      lineHeight: "1.42em",
      fontWeight: 600,
      marginTop: "0.142em",
      color: "rgba(22, 40, 112, 1)",
    },
  })
);

const PerspectivePeriod = (props: React.PropsWithChildren<{}>) => {
  const styles = usePerspectivePeriodStyles();
  return <div className={styles.root}>{props.children}</div>;
};

export default PerspectivePeriod;
